<template>
  <div class="picture__audio-icons">
    <div v-if="videotrue" class="picture__icon picture__icon_video" :title="$t('message.TipVideo')"/>
    <div v-if="audiotrue" class="picture__icon picture__icon_headfones" :title="$t('message.TipAudio')"/>
    <div v-if="workdesc" class="picture__icon" :title="$t('message.TipDesc')"><i class="icon7-doc-text"/></div>
    <div v-if="coords" class="picture__icon picture__icon_location" :title="$t('message.TipCoords')"><i class="icon7-location"/></div>
    <div v-if="digitaltrue" class="picture__icon picture__icon_digital" :title="$t('message.WorkSaleDigital')+' '+format_price(work.status_digital.price, work.status_digital.currency)"/>
    <div v-if="has_interior" class="picture__icon picture__icon_interior" :title="$t('message.TipInterior')"/>
    <span v-if="copyright" class="paint-label paint-label-copyright">&#160;</span>
  </div>
</template>

<script>
  import mixin_work from '../../mixins/mixin_work'

  export default {
    mixins: [mixin_work],
    name      : 'works-item-info',
    props: ['work'],
  }
</script>



// WEBPACK FOOTER //
// src/components/list/WorksItemInfo.vue